import React from 'react';
import { useTranslation } from 'react-i18next';
import { Form, Modal, Select } from 'antd';
import debounce from 'lodash.debounce';
import { useTransportPerformanceGroupsStore } from 'shared/stores/use-transport-performance-groups';
import type { IAddToGroupFormFields, IAddToGroupModalProps } from './types';

export const AddToGroupModal: React.FC<IAddToGroupModalProps> = (props) => {
  const { isOpen, onClose } = props;
  const { t } = useTranslation('transport-mileage');

  const { groups, selectedIds, addToGroup } = useTransportPerformanceGroupsStore();

  const [form] = Form.useForm<IAddToGroupFormFields>();
  const handleOk = debounce(() => form.submit(), 200);

  const groupOptions = Object.keys(groups).map((name) => ({ label: name, value: name }));

  const onFinishForm = (values: IAddToGroupFormFields) => {
    addToGroup(values.group, selectedIds);
    onClose();
    form.resetFields();
  };

  const handleClose = () => {
    form.resetFields();
    onClose();
  };

  return (
    <Modal title={t('add_to_group')} open={isOpen} onCancel={handleClose} onOk={handleOk}>
      <Form form={form} name='add_transport_to_group' layout='vertical' onFinish={onFinishForm}>
        <Form.Item label={t('group')} name='group' rules={[{ required: true, message: t('group_required') }]}>
          <Select placeholder={t('select_group_placeholder')} options={groupOptions} />
        </Form.Item>
      </Form>
    </Modal>
  );
};
